module.exports = __webpack_public_path__ + "static/media/ic_up_arrow_purple.97513919.svg";